module.exports = __webpack_public_path__ + "static/fu-logo-88f753a7d832c9261addbe924fd4336a.svg";